export default __webpack_public_path__ + "static/media/Bookmark Icon.55600cb0.png";